<div *ngIf="!autoOpenCheckIn">
  <ng-container *ngIf="mode === 'block' && canUseCheckIn">
    <div class="ps-medium nordic-blue-800-bg rounded-large white-text" data-testid="checkin-block">
      <div *ngIf="!allCustomersHasCheckedIn || isLegacyVersion">
        <h3 class="font-heading-4 ps-xsmall-b">
          {{
            'MMB.checkIn.state.open.title'
              | finLocalization: { destination: order.locations[bound.arrival.locationCode]?.cityName }
          }}
        </h3>
        <p *ngIf="isBoundApisRequired" class="font-body-1 ps-small-b">
          {{ 'MMB.checkIn.state.open.text' | finLocalization }}
        </p>
      </div>
      <div *ngIf="allCustomersHasCheckedIn">
        <h3 class="font-heading-4">
          {{
            'MMB.checkIn.state.allCheckedIn.title'
              | finLocalization: { destination: order.locations[bound.arrival.locationCode]?.cityName }
          }}
        </h3>
        <div class="ps-xsmall-y font-body-2">
          {{ 'MMB.checkIn.state.allCheckedIn.description' | finLocalization }}
        </div>
      </div>
      <div class="flex flex--end check-in-buttons">
        <fcom-button
          data-testid="check-in-boarding-pass-button"
          *ngIf="showBoardingPassButton"
          [size]="ButtonSize.MEDIUM"
          [icon]="{ name: SvgLibraryIcon.QRCODE, position: IconPosition.RIGHT }"
          [theme]="ButtonTheme.LIGHT_PRIMARY_CTA_HEATHER"
          [mode]="ButtonMode.FILL_MOBILE"
          [text]="'MMB.checkIn.state.actions.boardingPass' | finLocalization"
          (clickBtn)="redirectToBoardingPass()"
        ></fcom-button>
        <fcom-button
          data-testid="check-in-button"
          *ngIf="!allCustomersHasCheckedIn"
          [focus$]="checkInModalClosed$"
          [size]="ButtonSize.MEDIUM"
          [icon]="{
            name: isLegacyVersion ? SvgLibraryIcon.EXTERNAL_TAB : SvgLibraryIcon.CHECK_IN,
            position: IconPosition.RIGHT,
          }"
          [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
          [mode]="ButtonMode.FILL_MOBILE"
          [text]="'MMB.notifications.checkInOpen.linkText' | finLocalization"
          (clickBtn)="redirectToCheckIn()"
        ></fcom-button>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="mode === 'buttons' && (hasCheckedInCustomers || canUseCheckIn || showBoardingPassButton)">
    <div class="flex flex--end flex--wrap check-in-buttons pr-small-x pr-small-b" data-testid="checkin-buttons">
      <fcom-button
        data-testid="check-in-boarding-pass-button"
        *ngIf="showBoardingPassButton"
        [size]="ButtonSize.MEDIUM"
        [icon]="{ name: SvgLibraryIcon.QRCODE, position: IconPosition.RIGHT }"
        [theme]="ButtonTheme.LIGHT_PRIMARY_CTA_HEATHER"
        [mode]="ButtonMode.FILL_MOBILE"
        [text]="'MMB.checkIn.state.actions.boardingPass' | finLocalization"
        (clickBtn)="redirectToBoardingPass()"
      ></fcom-button>
      <fcom-button
        data-testid="check-in-button"
        *ngIf="canUseCheckIn && !allCustomersHasCheckedIn"
        [focus$]="checkInModalClosed$"
        [size]="ButtonSize.MEDIUM"
        [icon]="{ name: SvgLibraryIcon.CHECK_IN, position: IconPosition.RIGHT }"
        [mode]="ButtonMode.FILL_MOBILE"
        [text]="'MMB.notifications.checkInOpen.linkText' | finLocalization"
        (clickBtn)="redirectToCheckIn()"
      ></fcom-button>
      <fcom-button
        data-testid="modify-check-in-button"
        *ngIf="canUseCheckIn && hasCheckedInCustomers"
        [size]="ButtonSize.MEDIUM"
        [icon]="{ name: SvgLibraryIcon.TICKET_REFUND, position: IconPosition.RIGHT }"
        [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
        [mode]="ButtonMode.FILL_MOBILE"
        [text]="'MMB.checkIn.state.actions.modify' | finLocalization"
        (clickBtn)="redirectToModifyCheckIn()"
      ></fcom-button>
      <fcom-button
        data-testid="cancel-check-in-button"
        *ngIf="canUseCheckIn && hasCheckedInCustomers"
        [focus$]="cancelCheckInModalClosed$"
        [size]="ButtonSize.MEDIUM"
        [icon]="{ name: SvgLibraryIcon.ARROW_RIGHT, position: IconPosition.RIGHT }"
        [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
        [mode]="ButtonMode.FILL_MOBILE"
        [loading]="cancelCheckInInProgress"
        [text]="'MMB.checkIn.state.actions.cancel' | finLocalization"
        (clickBtn)="redirectToCancelCheckIn()"
      ></fcom-button>
    </div>
  </ng-container>
</div>

<ng-container *ngIf="!isLegacyVersion && canUseCheckIn">
  <fcom-modal
    data-testid="cancel-check-in-passenger-modal"
    [open]="cancelCheckInPassengerModalOpen"
    (close)="cancelCheckInModalClosed$.next(true)"
    (openChange)="cancelCheckInPassengerModalOpen = $event"
    [fitToContent]="true"
    [title]="'MMB.checkIn.passengerSelection.modal.titles.cancel.title' | finLocalization"
    [buttons]="ModalButtons.CUSTOM"
  >
    <div class="pr-large">
      <h3 class="font-heading-4 ps-small-b">
        {{ 'MMB.checkIn.passengerSelection.modal.titles.cancel.description' | finLocalization }}
      </h3>
      <ng-container [formGroup]="cancelCheckinForm">
        <div formGroupName="passengers">
          <ng-container *ngFor="let passenger of passengersWithCheckinInfo">
            <fcom-checkbox class="block ps-small-y" [formControlName]="passenger.id">
              <ng-container
                *ngTemplateOutlet="
                  passengerInfo;
                  context: {
                    passenger: passenger,
                    showAllFields: !passenger.isCheckedIn || !passenger.isAllowedToUseCheckIn,
                  }
                "
              ></ng-container>
            </fcom-checkbox>
          </ng-container>
        </div>
      </ng-container>
    </div>

    <div buttons>
      <div class="flex flex--center mobile-flex">
        <fcom-button
          class="mr-xsmall-r valign-middle"
          [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
          [text]="'actions.close' | finLocalization"
          (clickBtn)="closeCancelModal()"
        ></fcom-button>
        <fcom-button
          class="valign-middle"
          [aria]="{ disabled: !cancelCheckinForm.valid }"
          [loading]="cancelCheckInInProgress"
          data-testid="cancel-check-in-continue-button"
          [text]="'MMB.checkIn.passengerSelection.buttons.proceed.cancel' | finLocalization"
          (clickBtn)="cancelCheckIn()"
        ></fcom-button>
      </div>
    </div>
  </fcom-modal>

  <ng-template #passengerInfo let-passenger="passenger" let-showAllFields="showAllFields">
    <div class="custom-heading">{{ passenger.firstName }} {{ passenger.lastName }}</div>
    <div class="font-body-1 medium-type" *ngIf="passenger.withInfant">
      ({{
        'passenger.withInfant' | finLocalization: { withInfantFullName: passenger.withInfant } | finToLowerCase: ''
      }})
    </div>
    <ng-container *ngIf="showAllFields">
      <div class="font-body-2 regular-type" *ngIf="passenger.isCheckedIn">
        {{ 'MMB.checkIn.state.checkedIn' | finLocalization }}
      </div>
      <div class="font-body-2 regular-type" *ngIf="!passenger.isCheckedIn">
        {{ 'MMB.checkIn.state.notCheckedIn' | finLocalization }}
      </div>
      <div class="font-body-2 regular-type" *ngIf="!passenger.isAllowedToUseCheckIn">
        {{ 'MMB.checkIn.state.notEligible' | finLocalization }}
      </div>
    </ng-container>
  </ng-template>
</ng-container>
